import React,{useState,useEffect,useRef}from 'react'
import { Modal,message,Form,Input, DatePicker,} from 'antd';
import { useBnsGuangGaoFaBuUpdateQuery, useBnsGuangGaoFaBuUpdateSaveMutation,} from '../../store/ReactWebSiteApi';
import GetUserDept from '../../cpn/GetUserDept';
import dayjs from 'dayjs';
import ProductForm from '../../backend/project/ProjectSelect';
import MediaForm from '../../promote/media/MediaForm';
import GetUser from '../../cpn/GetUser';
import MyEditor from '../../cpn/MyEditor';
import PackageForm from '../../promote/package/PackageForm';
function PublishEdit(props) {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState({
        bggfb_e_date:''
    }); 
    const {data,isSuccess} = useBnsGuangGaoFaBuUpdateQuery({bggfb_id:props.bggfb_id},{skip:!open})
    const editForm = useRef()
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                editForm.current.setFieldsValue({
                    bggfb_content:data.Result.bggfb_content,
                    bggfb_dept_id:data.Result.bggfb_dept_id,
                    bggfb_meijie_id:data.Result.bggfb_meijie_id,
                    bggfb_fuzhuren_id:data.Result.bggfb_fuzhuren_id,
                    bggfb_bg_id:data.Result.bggfb_bg_id,
                    bggfb_jihuariqi:dayjs(data.Result.bggfb_jihuariqi),
                    "bggfb_name" : data.Result.bggfb_name,
                    "bggfb_bbz_id" : data.Result.bggfb_bbz_id,
                })
                setInfo(prevState=>({...prevState,         
                    bggfb_content:data.Result.bggfb_content,
                    bggfb_dept_id:data.Result.bggfb_dept_id,
                    bggfb_dept_name:data.Result.bggfb_dept_name,
                    bggfb_meijie_id:data.Result.bggfb_meijie_id,
                    bggfb_meijie_name:data.Result.bggfb_meijie_name,
                    bggfb_fuzhuren_id:data.Result.bggfb_fuzhuren_id,
                    bggfb_fuzhuren_name:data.Result.bggfb_fuzhuren_name,
                    bggfb_bg_id:data.Result.bggfb_bg_id,
                    bggfb_bg_name:data.Result.bggfb_bg_name,
                    bggfb_jihuariqi:data.Result.bggfb_jihuariqi,
                    "bggfb_name" : data.Result.bggfb_name,    
                    "bggfb_bbz_id" : data.Result.bggfb_bbz_id,    
                    "bggfb_bbz_name" : data.Result.bggfb_bbz_name,    
                }))
            }
        }
    },[data,isSuccess])
    const [goodsEdit] = useBnsGuangGaoFaBuUpdateSaveMutation()
    return (
        <>
            <a onClick={() => {setOpen(true)}}>修改</a>
            <Modal
                width={1000}                        
                open={open}
                title='修改项目'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            form.resetFields();
                            onCreateEdit(values);
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                    goodsEdit({
                        "bggfb_bg_id" : info.bggfb_bg_id,
                        "bggfb_bg_name" : info.bggfb_bg_name,
                        "bggfb_uid" : localStorage.getItem('eu_id'),
                        "bggfb_uname" : localStorage.getItem('eu_name'),
                        "bggfb_dept_id" : info.bggfb_dept_id,
                        "bggfb_dept_name" : info.bggfb_dept_name,
                        "bggfb_e_id" : localStorage.getItem('e_id'),
                        "bggfb_fuzhuren_id" : info.bggfb_fuzhuren_id,
                        "bggfb_fuzhuren_name" : info.bggfb_fuzhuren_name,
                        "bggfb_jihuariqi" : info.bggfb_jihuariqi,
                        "bggfb_meijie_id" : info.bggfb_meijie_id,
                        "bggfb_meijie_name" : info.bggfb_meijie_name,
                        "bggfb_name" : info.bggfb_name,
                        "bggfb_content" : info.bggfb_content,                          
                        "bggfb_id" : props.bggfb_id,                          
                        "bggfb_bbz_name" : info.bggfb_bbz_name,                          
                        "bggfb_bbz_id" : info.bggfb_bbz_id,                          
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {
                            message.success('修改成功！')   
                            setOpen(false)                             
                        }
                        if (res.data.Status === 'fail') {
                            message.error('修改失败！'+res.data.Message)
                        }
                    })
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name="form_client_edit"
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                    <GetUserDept 
                        label='部门'
                        required
                        wrapperCol={{span:10}} 
                        getUserDept={(e,f) => {
                            setInfo(prevState=>({...prevState,bggfb_dept_id:e,bggfb_dept_name:f}))
                        }}
                        name='bggfb_dept_id'
                    />
                    <ProductForm
                        wrapperCol={{span:10}}
                        required    
                        onChange={(e,f) => {
                            setInfo(prevState=>({...prevState,bggfb_bg_id:e,bggfb_bg_name:f.label}))
                        }}
                        name='bggfb_bg_id'
                    />
                    <PackageForm
                        onChange={(e,f) => {
                            setInfo(prevState=>({...prevState,bggfb_bg_id:e,bggfb_bg_name:f.label}))
                        }}
                        onChangePackage={(e,f) => {
                            setInfo(prevState=>({...prevState,bggfb_bbz_id:e,bggfb_bbz_name:f.label}))
                        }}
                        name='bggfb_bg_id'
                        namePackage='bggfb_bbz_id'
                    />
                    <MediaForm
                        wrapperCol={{span:10}}
                        required
                        onChange={(e,f) => {
                            setInfo(prevState=>({...prevState,bggfb_meijie_id:e,bggfb_meijie_name:f.label}))
                        }}
                        name='bggfb_meijie_id'
                    />
                    <GetUser
                        label='负责人'
                        required
                        wrapperCol={{span:10}} 
                        getUser={(e,f) => {
                            
                            setInfo(prevState=>({...prevState,bggfb_fuzhuren_id:e,bggfb_fuzhuren_name:f}))
                        }}
                        name='bggfb_fuzhuren_id'
                    />
                    <Form.Item
                        wrapperCol={{span:20}} 
                        style={{marginBottom:"0"}}
                        label='计划日期'
                        required
                        
                    >
                        <Form.Item name="bggfb_jihuariqi">
                            <DatePicker
                                    onChange={(e) => {setInfo(prevState=>({...prevState,bggfb_jihuariqi:dayjs(e).format('YYYY-MM-DD')}))}} 
                            />
                        </Form.Item>
                    </Form.Item>
                    <Form.Item name="bggfb_name" label='名称' wrapperCol={{span:20}} required>
                        <Input 
                            onChange={(e) => {setInfo(prevState=>({...prevState,bggfb_name:e.target.value}))}}
                        />
                    </Form.Item> 
                    <Form.Item name="bggfb_content" label='备注' wrapperCol={{span:20}}>
                        <MyEditor 
                            onChange={(e) => {setInfo(prevState=>({...prevState,bggfb_content:e}))}}
                        />
                    </Form.Item> 
                </Form>
            </Modal>
        </>
    )
}

export default PublishEdit